module.exports = __webpack_public_path__ + "img/mb1t4.311a8510.png";